/** Mirrors app/src/constants/subscription.ts — keep in sync. */
export const FREE_TIER_LIMITS = {
  journeys: 3,
  stepsPerJourney: 30,
  montagesPerJourney: 1,
} as const;

export const PRO_PRICE_LABEL = "$5/month";

export type PricingPlan = {
  id: "free" | "pro";
  name: string;
  price: string;
  period: string;
  description: string;
  features: string[];
  highlighted?: boolean;
};

export const PRICING_PLANS: PricingPlan[] = [
  {
    id: "free",
    name: "Free",
    price: "$0",
    period: "forever",
    description:
      "Start a journey, log daily steps, and build your first montage.",
    features: [
      `${FREE_TIER_LIMITS.journeys} journeys`,
      `${FREE_TIER_LIMITS.stepsPerJourney} video or image steps per journey`,
      `${FREE_TIER_LIMITS.montagesPerJourney} montage per journey`,
      "Unlimited text steps",
      "Friends feed and sharing",
    ],
  },
  {
    id: "pro",
    name: "Pro",
    price: "$5",
    period: "/month",
    description:
      "Keep every chapter of proof — unlimited journeys, steps, and montages.",
    features: [
      "Unlimited journeys",
      "Unlimited video and image steps",
      "Unlimited montages",
      "Everything in Free",
      "Cancel anytime in the app",
    ],
    highlighted: true,
  },
];
